import React from 'react';
import { connect } from 'react-redux';
import { ErrorOverlay } from '@ff-os/shared-react/components/error-overlay/ErrorOverlay';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { actions as photoActions } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpDispatch } from '@ff-scene-plugins/photo-prints-redux/store';
import classNames from 'classnames';
import styles from './PhotoPrintDesktopErrorOverlay.module.scss';

const _PhotoPrintErrorOverlay = ({ removePhoto }: Props) => {
    return (
        <ErrorOverlay>
            <div onClick={removePhoto}
                className={classNames(styles.remove, styles.button)}>
                <Icon type='general-ui-bin' size='small' />
            </div>
        </ErrorOverlay>
    );
};

type OwnProps = {
    photoId: string;
};

type Props = OwnProps & {
    removePhoto: () => void;
};

const mapDispatchToProps = (dispatch: PhotoPrintsPdpDispatch, ownProps: OwnProps) => ({
    removePhoto: () => dispatch(photoActions.remove(ownProps.photoId))
});

export const PhotoPrintDesktopErrorOverlay = connect(
    null,
    mapDispatchToProps
)(_PhotoPrintErrorOverlay);